import { type ErrorsHandbook, ErrorsHandbookBuilder, createErrorHandbook } from '@/6_shared/api'

export const eventErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(404).build(),
  ...new ErrorsHandbookBuilder(500).build()
})
